import { withStyles } from "@material-ui/core/styles";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { useDispatch, useSelector } from "react-redux";
import {
  checkedForCompareChanged,
  getCheckedForCompareForResponseId,
  updateCheckedForCompareToDb,
  updateTotalSelected,
} from "../store/quotes";
import { useEffect, useRef } from "react";

const CustomSwitchMUI = (props) => {
  const isMounted = useRef(false);

  const { responseid } = props;

  const checkedforcompare = useSelector(
    getCheckedForCompareForResponseId({ responseid })
  );

  const dispatch = useDispatch();

  const handleCheck = (event) => {
    dispatch(
      updateCheckedForCompareToDb({
        responseid,
        checkedstate: event.target.checked,
      })
    );

    console.log(event.target.checked);
  };

  useEffect(() => {
    if (isMounted.current) dispatch(updateTotalSelected());
  }, [checkedforcompare, dispatch]);

  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true;
    }
  }, []);

  return (
    <FormControlLabel
      control={
        <GreenSwitch checked={checkedforcompare} onChange={handleCheck} />
      }
    ></FormControlLabel>
  );
};

const GreenSwitch = withStyles({
  switchBase: {
    color: "white",
    "&$checked": {
      color: "white",
    },
    "&$checked + $track": {
      backgroundColor: "#2C9923",
    },
  },
  checked: {},
  track: {},
})(Switch);

export default CustomSwitchMUI;
